import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Menu } from '@vtbhome/juicyfront';
import { DropdownSortOption, DropdownSortProps } from './types';
import { DropdownHead, Wrapper } from './dropdown-sort.styles';
import { ArrowsChevronDown } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '@shared/config/colors/colors';
import { IListElement } from '@vtbhome/juicyfront/types';
import { useOutsideClick } from '@shared/lib/hooks/use-click-outside/use-click-outside';

export const DropdownSort: React.FC<DropdownSortProps> = ({ options, value, menuProps, onChange }) => {
    const [isShow, setIsShow] = useState(false);

    const parentRef = useOutsideClick<HTMLDivElement>({ callback: () => setIsShow(false) });
    const containerRef = useRef<HTMLDivElement>(null);

    const handleClickOption = useCallback(
        (value: DropdownSortOption) => () => {
            onChange(value);
            setIsShow(false);
        },
        [onChange]
    );

    const list = useMemo(() => {
        return options.map((option) => {
            return {
                label: option.label,
                value: option.value,
                disabled: option.disabled,
                handler: handleClickOption(option),
            } as IListElement;
        });
    }, [options, handleClickOption]);

    return (
        <Wrapper ref={parentRef}>
            <Menu {...menuProps} list={list} containerRef={containerRef}>
                <DropdownHead $isShowMenu={isShow} onClick={() => setIsShow(!isShow)}>
                    <Typography size='button1' color='inherit'>
                        {value.label}
                    </Typography>
                    <ArrowsChevronDown size='xxs' color={COLORS.neutral_50} />
                </DropdownHead>
            </Menu>
            <div ref={containerRef}></div>
        </Wrapper>
    );
};
